module.exports = __webpack_public_path__ + "static/media/att_32.8e1bcec4.jpg";